import * as React from 'react';

export function IconMastercard(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 54 32" fill="none" {...props}>
      <title>Mastercard</title>
      <g clipPath="url(#prefix__clip0_16_41)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0h53.333v32H0V0z"
          fill="#fff"
        />
        <path d="M22.96 8.94h7.897v14.476H22.96V8.941z" fill="#FF5F00" />
        <path
          d="M23.461 16.18c-.003-2.825 1.268-5.495 3.447-7.24-3.7-2.966-9.015-2.534-12.208.993-3.193 3.527-3.193 8.964 0 12.49 3.193 3.527 8.508 3.96 12.208.993-2.178-1.744-3.45-4.412-3.447-7.236z"
          fill="#EB001B"
        />
        <path
          d="M41.512 16.18c0 3.524-1.973 6.74-5.081 8.28a8.882 8.882 0 01-9.523-1.044c2.177-1.745 3.449-4.413 3.449-7.237 0-2.825-1.272-5.493-3.449-7.238a8.881 8.881 0 019.523-1.043c3.108 1.54 5.081 4.755 5.081 8.28v.002zm-.862 5.832v-.404h.117v-.084h-.298v.084h.128v.404h.053zm.579 0v-.488h-.09l-.105.348-.106-.348h-.08v.488h.065v-.366l.098.317h.067l.098-.317v.37l.053-.004z"
          fill="#F79E1B"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0_16_41">
          <path fill="#fff" d="M0 0h53.333v32H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
